<template>
	<div>
		<list-component
			entity-url="/projects_other"
			entities-path="projects_other"
			entity-type="project_other"
			entity-name="Список проектов НДС и ВП"
			entity-badge=""
			search-placeholder="Поиск по ИД"
			:sort-config="sortConfig"
			:filter-config="filterConfig"
			:enable-tags="$store.getters.permissions.includes('enable_tagging')"
			:enable-create="enableProjectCreateEdit"
			:allow-goto-end-buttons="true"
			:entity-exportable="$store.getters.permissions.includes('enable_projects_export')"
		>
			<template v-slot:header="slotProps">
				<span class="text-truncate small text-muted font-size-14">
					{{ slotProps.row.project_type ? slotProps.row.project_type : 'Тип не указан' }}
				</span>
			</template>

			<template v-slot:files="slotProps">
				<b-dropdown v-if="slotProps.row.list_media.length" dropright no-caret text="Файлы" variant="link" size="sm" class="btn-text-inline-dropdown mr-2 text-nowrap">
					<template v-slot:button-content>
						<span class="far fa-paperclip fa-fw"></span> 
						<decl-of-num class="d-none d-md-inline-block" :number="slotProps.row.list_media.length" :titles="['файл', 'файла', 'файлов']" :print="true"/>
						<span class="d-inline-block d-md-none">{{ slotProps.row.list_media.length }}</span>
					</template>
					<div class="d-flex">

						<media-collection
						v-if="slotProps.row.list_media.filter(o => o.collection_name === 'default').length"
						class="px-2 py-1"
						title="Заявка"
						:files="slotProps.row.list_media"
						:collection-name="'default'"
						:mode="'show'"
						/>
				
						<media-collection
						v-if="slotProps.row.list_media.filter(o => o.collection_name === 'review_media').length"
						class="px-2 py-1"
						title="Согласование"
						:files="slotProps.row.list_media"
						:collection-name="'review_media'"
						:mode="'show'"
						/>

					</div>
				</b-dropdown>
			</template>

			<template v-slot:body="slotProps">
				<div class="card-body d-flex flex-wrap px-2 py-0">
					<div class="order-2 order-md-2 col-9 col-sm-4 col-lg-2 p-0">
						<!-- Исходящее -->
						<div class="p-1 p-sm-2">
							<div>
								<div
								v-if="slotProps.row.status_review"
								:class="'text-truncate line-height-1 font-size-14 mb-2 text-' + slotProps.row.status_review.color"
								>
									<span class="far fa-fw mr-1" :class="'fa-' + slotProps.row.status_review.icon"></span><span :style="slotProps.row.status_review.url ? 'text-decoration: underline;' : ''">{{ slotProps.row.status_review.text }}</span>
								</div>
								<div class='line-height-1-5 font-size-14 d-flex flex-column'>
									<div class="text-muted font-size-14 line-height-1-25 mb-1" v-if="slotProps.row.project_review">
										Исх: {{ (slotProps.row.project_review.review_title ? '№' : '') + (slotProps.row.project_review.review_outgoing_date ? moment(slotProps.row.project_review.review_outgoing_date).format('D MMMM Y') : '') }}
									</div>
									<div v-if="slotProps.row.approver" class="d-flex align-items-center">
										<span class="mr-2" v-b-tooltip.hover.html="'Согласователь'"><span class="far fa-sitemap fa-fw text-muted"></span></span>
										<router-link class="d-flex text-truncate" :to="'/departments/' + slotProps.row.approver.id">
											<span class="line-height-1-25 d-inline-block text-truncate">{{ slotProps.row.approver.title }}</span>
										</router-link>
									</div>
									<div v-if="slotProps.row.regions && slotProps.row.regions.length" class="d-flex align-items-center mb-1">
										<span class="mr-2" v-b-tooltip.hover.html="'Регионы'"><span class="far fa-map fa-fw text-muted"></span></span>
										<div class="d-flex flex-column text-truncate">
											<router-link
												v-for="region in slotProps.row.regions"
												:key="region.id"
												class="d-flex text-truncate"
												:to="'/region/' + region.id"
												>
												<span class="line-height-1-25 d-inline-block text-truncate">{{ region.title }}</span>
											</router-link>
										</div>
									</div>
									<div v-if="slotProps.row.discussion_opened || slotProps.row.discussion_count">
										<router-link
											class="font-size-14 mb-1" 
											:class="slotProps.row.discussion_opened ? 'text-danger' : 'text-muted'"
											:to="'/projects_other/' + slotProps.row.id + '/discussion'"
											>
												<template v-if="slotProps.row.discussion_opened">
													<span class='fal fa-comment-alt-exclamation fa-fw'></span> Обсуждение открыто
												</template>
												<template v-else>
													<span class='fal fa-comment-alt-check fa-fw'></span> Обсуждение закрыто
												</template>
										</router-link>
									</div>
								</div>
							</div>
						</div>
						<!-- / Исходящее -->
					</div>
					<div class="order-3 order-md-3 col-12 col-sm-8 col-lg-6 p-0">
						<!-- Входящее -->
						<div class="p-1 p-sm-2">
							<div
								v-if="slotProps.row.incoming_number"
								class="text-muted font-size-14">
								Вх: <highlight-text :needle="slotProps.search ? slotProps.search.toString() : ''" :haystack="slotProps.row.incoming_number.toString()" maxlen="100"/>
								<span v-if="slotProps.row.incoming_date">
									от {{ moment(slotProps.row.incoming_date).format('D MMMM Y') }}
								</span>
							</div>
							<router-link
								class="d-block line-height-1-25 mb-2"
								:to="'/projects_other/' + slotProps.row.id"
								>
								<span v-html="slotProps.row.title_matches ? slotProps.row.title_matches : slotProps.row.title"></span> 
							</router-link>
							<div>

							<!-- Все статусы и информационные сообщения Согласования -->
							<div
							v-if="slotProps.row.status_data && slotProps.row.status_data.length"
							class="d-flex flex-wrap gap-2 font-size-14 border-top pt-2"
							>
								<div v-for="statusItem in slotProps.row.status_data">
									<component
									:is="statusItem.url ? 'router-link' : 'div'"
									:to="statusItem.url"
									class=""
									:class="'text-' + statusItem.color"
									>
										<span class="far fa-fw mr-1" :class="'fa-' + statusItem.icon"></span><span :style="statusItem.url ? 'text-decoration: underline;' : ''">{{ statusItem.text }}</span>
									</component>
								</div>
							</div>


							</div>
						</div>
						<!-- / Входящее  -->
					</div>
					<div class="order-4 order-md-4 col-12 col-sm-6 col-lg-4 p-0">
						<div class="p-1 p-sm-2 font-size-14">
							<div class="text-muted">Заявитель</div>
							<card-field-component
							class="mb-1"
							:no-margin="true"
							:no-title="true"
							type="organization_data"
							title="Заявитель"
							fieldname="applicant_json"
							v-model="slotProps.row.applicant_json"
							:display-value="slotProps.row.applicant_json"
							:fallback-value="{
								organization: slotProps.row.applicant,
								organization_branch: slotProps.row.applicant_branch,
								individual: slotProps.row.applicant_individual
							}"
							:mode="'show'"
							/>
							<div class="text-muted">Водопользователь</div>
							<card-field-component
							:no-margin="true"
							:no-title="true"
							type="organization_data"
							title="Водопользователь"
							fieldname="customer_json"
							v-model="slotProps.row.customer_json"
							:display-value="slotProps.row.customer_json"
							:fallback-value="{
								organization: slotProps.row.customer,
								organization_branch: slotProps.row.customer_branch,
								individual: slotProps.row.customer
							}"
							:mode="'show'"
							/>
						</div>
					</div>
				</div>
			</template>

		</list-component>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		components: {
		},
		data: function () {
			return {
				moment: moment,
				sortConfig: [
					{name: 'ИД', type: 'amount', field: 'id'},
					{name: 'Дата входящего', type: 'date', field: 'incoming_date'},
					{name: 'Дата исходящего', type: 'date', field: 'review_outgoing_date'},
					{name: 'Дата добавления', type: 'date', field: 'created_at'},
					{name: 'Дата изменения', type: 'date', field: 'updated_at'}
				]
			}
		},
		methods: {
		},
		mounted: function () {
		},
		computed: {
			enableProjectCreateEdit () {
				let shouldBeEnabled = ['enable_nds_project_create_edit', 'enable_wateruse_project_create_edit']
				if (this.$store.getters.permissions.some(o => shouldBeEnabled.includes(o))) {
					return true
				}
				return false
			},
			filterConfig () {

				var availableProjectTypes = []

				if (this.$store.getters.permissions.includes('enable_nds_projects_list')) {
					availableProjectTypes.push({
							value: 'n',  text: 'Согласование нормативов допустимых сбросов'
					})
				}

				if (this.$store.getters.permissions.includes('enable_wateruse_projects_list')) {
					availableProjectTypes.push({
							value: 'v',  text: 'Согласование условий водопользования'
					})
				}
				
				var arr = [
					{
						filterType: 'select',
						filterIcon: 'search',
						filterField: 'search_mode',
						filterDefault: 'Искать по номеру',
						filterName: 'Где искать',
						filterList: [
							{ value: 'organization_ogrn', text: 'По ОГРН организации'},
							{ value: 'phys', text: 'По физ. лицу'}
						]
					},
					{
						filterType: 'select',
						filterIcon: 'table',
						filterField: 'paging',
						filterDefault: '10 элементов',
						filterName: 'Показывать по',
						filterList: [
							{ value: 20, text: '20 элементов'},
							{ value: 40, text: '40 элементов'},
						]
					},
					{
						filterType: 'select',
						filterIcon: '',
						filterField: 'status',
						filterDefault: 'Любой',
						filterName: 'Статус согласования',
						filterList: [
							{ value: 'none',  text: 'В ожидании + Просрочено'},
							{ value: 'overdue', 'text': 'Просрочено'},
							{ value: 'overdue_soon', 'text': 'Заканчивается срок'},
							{ value: 'approved', 'text': 'Согласован'},
							{ value: 'declined', 'text': 'Отклонен'},
							{ value: 'any', 'text': 'Согласован + Отклонен'}
						]
					},
					{
						filterType: 'select',
						filterIcon: '',
						filterField: 'status_works',
						filterDefault: 'Любой',
						filterName: 'Статус деятельности',
						filterList: [
							{ value: 'd',  text: 'Деятельность завершена'},
							{ value: 'p', 'text': 'Деятельность выполняется'},
							{ value: 'c', 'text': 'Деятельность отменена'}
						]
					},
					{
						filterType: 'range',
						filterIcon: '',
						filterField: 'days',
						filterName: 'Дни согласования',
						filterMeasure: 'д'
					},
					{
						filterType: 'select',
						filterIcon: '',
						filterField: 'project_type',
						filterDefault: 'Все типы',
						filterName: 'Тип деятельности',
						filterList: availableProjectTypes
					},
					{
						filterType: 'select',
						filterIcon: '',
						filterField: 'is_complex_nds',
						filterDefault: 'Не важно',
						filterName: 'КЭР',
						filterList: [
							{value: 'y',  text: 'Есть КЭР'}
						]
					},
					{
						filterType: 'entity',
						filterIcon: 'sitemap',
						filterField: 'approver',
						filterName: 'Согласователь',
						filterEntityName: 'department',
						filterEntityUrl: 'departments',
						filterModalTitle: 'Выбор территориального управления'
					},
					{
						filterType: 'entity',
						filterIcon: 'sitemap',
						filterField: 'charge_department',
						filterName: 'Зона ответственности',
						filterEntityName: 'department',
						filterEntityUrl: 'departments',
						filterModalTitle: 'Выбор территориального управления'
					},
					{
						filterType: 'entity',
						filterIcon: 'map',
						filterField: 'region',
						filterName: 'Регион',
						filterEntityName: 'region',
						filterEntityUrl: 'regions',
						filterModalTitle: 'Выбор региона'
					},
					{
						filterType: 'entity',
						filterIcon: 'water',
						filterField: 'waterbasin',
						filterName: 'Водный бассейн',
						filterEntityName: 'waterbasin',
						filterEntityUrl: 'waterbasins',
						filterModalTitle: 'Выбор водного бассейна'
					},
					{
						filterType: 'entity',
						filterIcon: 'tint',
						filterField: 'waterobject',
						filterName: 'Водный объект',
						filterEntityName: 'waterobject',
						filterEntityUrl: 'waterobjects',
						filterModalTitle: 'Выбор водного объекта'
					},
					{
						filterType: 'entity',
						filterIcon: 'landmark',
						filterField: 'municipality',
						filterName: 'Муниципальное образование',
						filterEntityName: 'municipality',
						filterEntityUrl: 'municipalities',
						filterModalTitle: 'Выбор муниципального образования'
					},
					{
						filterType: 'organization_data',
						filterName: 'Организация',
						filterField: 'organization_data'
					},
					{
						filterType: 'select',
						filterIcon: 'paperclip',
						filterField: 'files',
						filterDefault: 'Не важно',
						filterName: 'Файлы',
						filterList: [
							{ value: 'no', 'text': 'Нет файлов' },
							null,
							{
								header: 'Основные документы',
								items: [
									{ value: 'has_review', text: 'Есть согласование'},
									{ value: 'no_review', text: 'Нет согласования'}
								]
							}
						]
					},
					{
						filterType: 'select',
						filterIcon: 'comment-alt',
						filterField: 'has_discussion',
						filterDefault: 'Не важно',
						filterName: 'Обсуждение',
						filterList: [
							{ value: 'opened', 'text': 'Обсуждение открыто' },
							{ value: 'closed', 'text': 'Обсуждение закрыто' },
							{ value: 'not_exists', 'text': 'Не было обсуждения' }
						]
					},
					{
						filterType: 'date-range',
						filterIcon: 'inbox-out',
						filterField: 'review_outgoing_date',
						filterName: 'Дата исходящего',
					},
					{
						filterType: 'date-range',
						filterIcon: 'inbox-in',
						filterField: 'incoming_date',
						filterName: 'Дата входящего',
					}
				]

				if (this.$store.getters.permissions.includes('show_profiles')) {
					arr.push({
						filterType: 'entity',
						filterIcon: 'user',
						filterField: 'created_by',
						filterName: 'Кем создано',
						filterEntityName: 'user',
						filterEntityUrl: 'users',
						filterModalTitle: 'Выбор пользователя'
					})
				}
				if (this.$store.getters.permissions.includes('enable_tagging')) {
					arr.push({
						filterType: 'tag',
						filterField: 'tag'
					})
				}

				if (this.$store.getters.permissions.some(o => ['enable_hoz_projects_list_deleted', 'enable_nds_projects_list_deleted', 'enable_wateruse_projects_list_deleted'].includes(o))) {
					arr.push({
							filterType: 'checkbox',
							filterIcon: 'trash-alt',
							filterName: 'Корзина',
							filterField: 'deleted'
					})
				}

				/**
				 * В массив фильтров добавим старй фильтр по поиску организации – для Миши
				 * ВРЕМЕННЫЙ
				 */

				if (this.$store.getters.profile.is_admin) {
					arr.push({
						filterType: 'entity',
						filterIcon: 'building',
						filterField: 'organization',
						filterName: 'Организация (старая)',
						filterEntityName: 'organization',
						filterEntityUrl: 'organizations',
						filterModalTitle: 'Выбор организации'
					})
				}

				return arr
			}
		}
	}
</script>